export default __webpack_public_path__ + "static/media/alert.7d7dc550.mp3";